import { FormSizesCode } from '../codeHighlights/forms/FormSizesCode';

const FormSizes = () => {
  return (
    <>
      <h2 className="mt-5">Form sizes</h2>
      <form noValidate={true} method="" id="bootstrapForm4">
        <div className="form-group mb-3">
          <label className="form-label" htmlFor="floatingInput2">
            Extra large
          </label>
          <input
            className="form-control form-control-lg"
            type="text"
            placeholder=".form-control-lg"
            aria-label=".form-control-lg example"
          />
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="floatingInput2">
            Standard
          </label>
          <input
            className="form-control"
            type="text"
            placeholder="Default input"
            aria-label="default input example"
          />
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="floatingInput2">
            Small
          </label>
          <input
            className="form-control form-control-sm"
            type="text"
            placeholder=".form-control-sm"
            aria-label=".form-control-sm example"
          />
        </div>
      </form>

      <div className="mt-5">
        <FormSizesCode />
      </div>
    </>
  );
};

export default FormSizes;
